import React, { useState, useEffect } from "react";
import { images } from "../assets/styles/Images";

/**
 * Renders a remote feeling/reason icon from its `icon_url`.
 * Icons are admin-managed (dynamic). If the URL is missing or fails to load,
 * we fall back to the bundled fileImage.png placeholder (NOT the profile/avatar
 * placeholder).
 */
const RemoteIcon = ({ src, alt = "icon", className = "", ...rest }) => {
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setErrored(false);
  }, [src]);

  const resolvedSrc = !src || errored ? images.fileImage : src;

  return <img src={resolvedSrc} alt={alt} className={className} onError={() => setErrored(true)} {...rest} />;
};

export default RemoteIcon;
